/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ResolveRefundByAttemptRequest interface.
 */
export function instanceOfResolveRefundByAttemptRequest(value) {
    if (!('composeId' in value) || value['composeId'] === undefined)
        return false;
    return true;
}
export function ResolveRefundByAttemptRequestFromJSON(json) {
    return ResolveRefundByAttemptRequestFromJSONTyped(json, false);
}
export function ResolveRefundByAttemptRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'composeId': json['compose_id'],
    };
}
export function ResolveRefundByAttemptRequestToJSON(json) {
    return ResolveRefundByAttemptRequestToJSONTyped(json, false);
}
export function ResolveRefundByAttemptRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'compose_id': value['composeId'],
    };
}
